import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05fef075"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "city-update" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = { class: "border bg-white px-6 py-4 mt-6" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col items-center text-sm select-none text-gray-400"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Загрузка данных о городе...", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-red-500" }, "При получении данных о городе произошла ошибка", -1))
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_10 = { class: "grid grid-cols-4 gap-3" }
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Укажите центр города", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, " Для указания центра города, нажмите на карте ", -1))
const _hoisted_14 = { class: "mt-2 relative" }
const _hoisted_15 = {
  key: 0,
  class: "absolute right-3 top-3 flex flex-col z-10",
  style: {"min-width":"264px"}
}
const _hoisted_16 = {
  key: 0,
  class: "flex flex-col items-center justify-center mt-3 select-none text-sm text-gray-400 bg-white border p-3"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Поиск результатов...", -1))
const _hoisted_18 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_19 = { key: 2 }
const _hoisted_20 = {
  key: 0,
  class: "border text-sm bg-white mt-3 max-h-40 overflow-hidden overflow-y-auto"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "font-semibold" }
const _hoisted_23 = { class: "font-xs text-gray-500" }
const _hoisted_24 = { class: "mt-4" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Укажите границы области просмотра города", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, " Для перемещения прямоугольника перетащите его, либо нажмите на карте ", -1))
const _hoisted_27 = { class: "relative" }
const _hoisted_28 = {
  key: 0,
  class: "absolute p-3 border bg-white right-3 top-3 flex flex-col items-center z-10"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus mr-2" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrows-alt mr-2" }, null, -1))
const _hoisted_32 = { class: "mt-6 flex items-center justify-end" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_new_map = _resolveComponent("new-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Редактирование города" }),
      _createVNode(_component_the_button, {
        class: "second text small",
        onClick: _ctx.onBack
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.city_state.is_loading || _ctx.city_state.is_failed || !_ctx.city_state.city)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.city_state.is_loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_loader, { class: "primary" }),
                  _hoisted_6
                ], 64))
              : (_ctx.city_state.is_failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_7,
                    _createVNode(_component_the_button, {
                      class: "mt-1",
                      onClick: _ctx.loadCity
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Перезагрузить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : (!_ctx.city_state.city)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Нет данных о городе"))
                  : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_the_input, {
                  value: _ctx.state.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
                  "is-invalid": _ctx.state_form$.name.$error,
                  "validation-errors": _ctx.state_form$.name.$errors,
                  placeholder: "Название города"
                }, null, 8, ["value", "is-invalid", "validation-errors"]),
                _createVNode(_component_the_input, {
                  value: _ctx.state.nameKz,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.nameKz) = $event)),
                  "is-invalid": _ctx.state_form$.nameKz.$error,
                  "validation-errors": _ctx.state_form$.nameKz.$errors,
                  placeholder: "Название города (KZ)"
                }, null, 8, ["value", "is-invalid", "validation-errors"]),
                _createVNode(_component_the_input, {
                  value: _ctx.state.nameEn,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.nameEn) = $event)),
                  "is-invalid": _ctx.state_form$.nameEn.$error,
                  "validation-errors": _ctx.state_form$.nameEn.$errors,
                  placeholder: "Название города (EN)"
                }, null, 8, ["value", "is-invalid", "validation-errors"]),
                _createVNode(_component_the_input, {
                  value: _ctx.state.nameZh,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.nameZh) = $event)),
                  "is-invalid": _ctx.state_form$.nameZh.$error,
                  "validation-errors": _ctx.state_form$.nameZh.$errors,
                  placeholder: "Название города (ZH)"
                }, null, 8, ["value", "is-invalid", "validation-errors"])
              ]),
              _createVNode(_component_the_select, {
                value: _ctx.state.region_id,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.region_id) = $event)),
                placeholder: "Регион",
                "is-invalid": _ctx.state_form$.region_id.$error,
                "validation-errors": _ctx.state_form$.region_id.$errors,
                loading: _ctx.data_state.regions.is_loading,
                options: _ctx.data_state.regions.list,
                "search-by": "name",
                label: "name"
              }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options"]),
              _createVNode(_component_the_select, {
                value: _ctx.state.type_id,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.type_id) = $event)),
                placeholder: "Тип",
                "is-invalid": _ctx.state_form$.type_id.$error,
                "validation-errors": _ctx.state_form$.type_id.$errors,
                loading: false,
                options: _ctx.CitiesTypes,
                searchable: false,
                label: "name"
              }, null, 8, ["value", "is-invalid", "validation-errors", "options"]),
              _createVNode(_component_the_select, {
                value: _ctx.state.statusId,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.statusId) = $event)),
                placeholder: "Статус",
                "can-deselect": "",
                options: _ctx.STATUS_OPTIONS,
                class: "w-full mt-2",
                searchable: false
              }, null, 8, ["value", "options"]),
              _createVNode(_component_the_input, {
                value: _ctx.state.airCode,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.airCode) = $event)),
                placeholder: "Авиа код"
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                value: _ctx.state.postCode,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.postCode) = $event)),
                placeholder: "Почтовый индекс"
              }, null, 8, ["value"]),
              _createVNode(_component_the_select, {
                value: _ctx.state.dispatcherSectorId,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.dispatcherSectorId) = $event)),
                placeholder: "Диспетчер сектор",
                "search-without-refresh": "",
                "can-deselect": "",
                loading: _ctx.data_state.dispatcher_sectors.is_loading,
                failed: _ctx.data_state.dispatcher_sectors.is_failed,
                options: _ctx.data_state.dispatcher_sectors.list,
                onRefresh: _ctx.loadDispatcherSectors
              }, null, 8, ["value", "loading", "failed", "options", "onRefresh"]),
              _createVNode(_component_checkbox, {
                label: "Включить авиа",
                value: _ctx.state.isAviaEnable,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.isAviaEnable) = $event)),
                class: "mt-2"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                (_ctx.state.is_center_map_ready)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_the_input, {
                        value: _ctx.search_state.query,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.search_state.query) = $event)),
                        placeholder: "Поиск",
                        onInput: _ctx.geocode
                      }, null, 8, ["value", "onInput"]),
                      (
                                    _ctx.search_state.is_loading ||
                                    _ctx.search_state.is_failed ||
                                    (_ctx.search_state.results.length === 0 &&
                                        Boolean(_ctx.search_state.query))
                                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            (_ctx.search_state.is_loading)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_loader, { class: "primary" }),
                                  _hoisted_17
                                ], 64))
                              : (_ctx.search_state.is_failed)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Произошла ошибка, попробуйте еще раз "))
                                : (
                                        _ctx.search_state.results.length === 0 &&
                                        Boolean(_ctx.search_state.query)
                                    )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, " По вашему запросу ничего не найдено "))
                                  : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (Boolean(_ctx.search_state.query))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.search_state.results, (result, i) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: `result-${i}`,
                                      class: "transition-all px-3 py-2 border-t hover:bg-blue-50 cursor-pointer",
                                      onClick: ($event: any) => (_ctx.onSelectAddress(result))
                                    }, [
                                      _createElementVNode("div", _hoisted_22, _toDisplayString(result.name), 1),
                                      _createElementVNode("div", _hoisted_23, _toDisplayString(result.description), 1)
                                    ], 8, _hoisted_21))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_new_map, {
                  id: "center-map",
                  controls: ['zoomControl'],
                  zoom: 10,
                  onMapReady: _ctx.onMapReady,
                  onClick: _ctx.onMapClick
                }, null, 8, ["onMapReady", "onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                (_ctx.state.is_border_map_ready)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createVNode(_component_the_button, {
                        class: "primary small",
                        onClick: _ctx.onIncreaseRectangle
                      }, {
                        default: _withCtx(() => [
                          _hoisted_29,
                          _createTextVNode(" Увеличить прямоугольник ")
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_the_button, {
                        disabled: _ctx.isDecreaseDisabled,
                        class: "primary small mt-3",
                        onClick: _ctx.onDecreaseRectangle
                      }, {
                        default: _withCtx(() => [
                          _hoisted_30,
                          _createTextVNode(" Уменьшить прямоугольник ")
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"]),
                      _createVNode(_component_the_button, {
                        class: "w-full primary small mt-3",
                        onClick: _ctx.onMoveToCenterRectangle
                      }, {
                        default: _withCtx(() => [
                          _hoisted_31,
                          _createTextVNode(" Переместить в центр ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.is_center_map_ready)
                  ? (_openBlock(), _createBlock(_component_new_map, {
                      key: 1,
                      class: "mt-2",
                      id: "borders-map",
                      controls: ['zoomControl'],
                      zoom: 10,
                      onMapReady: _ctx.onBorderMapReady,
                      onClick: _ctx.onBorderMapClick
                    }, null, 8, ["onMapReady", "onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_the_button, {
                disabled: _ctx.state.is_loading,
                loading: _ctx.state.is_loading,
                class: "small primary",
                onClick: _ctx.updateCity
              }, {
                default: _withCtx(() => [
                  _hoisted_33,
                  _createTextVNode(" Сохранить город ")
                ]),
                _: 1
              }, 8, ["disabled", "loading", "onClick"])
            ])
          ], 64))
    ])
  ]))
}